import React from "react";
import { HomepageLinkProps } from "SharedConstants/Schema";

export function HomepageLink(props: HomepageLinkProps) {
  return <a href={props.HomepageUrl}>{props.HomepageText}</a>;
}

export function DashboardLink() {
  return <a href="/Home/Dashboard">Return to Dashboard</a>;
}
